import React, { useEffect } from 'react';
import { isMobile, popupStore } from '@pascal/pascal-core';
import { gameLiveConnection } from '../services';

export function getBrowserVisibilityProp() {
  if (typeof document.hidden !== 'undefined') {
    return 'visibilitychange';
  }
  if (typeof document.msHidden !== 'undefined') {
    return 'msvisibilitychange';
  }
  if (typeof document.webkitHidden !== 'undefined') {
    return 'webkitvisibilitychange';
  }
  return null;
}

export function getBrowserDocumentHiddenProp() {
  if (typeof document.hidden !== 'undefined') {
    return 'hidden';
  }
  if (typeof document.msHidden !== 'undefined') {
    return 'msHidden';
  }
  if (typeof document.webkitHidden !== 'undefined') {
    return 'webkitHidden';
  }
  return null;
}

export function getIsDocumentHidden() {
  return !document[getBrowserDocumentHiddenProp()];
}

let start;
let end;
const duration = 7;

export function useVisibilityChange() {
  const [isVisible, setIsVisible] = React.useState(getIsDocumentHidden());
  const onVisibilityChange = () => setIsVisible(getIsDocumentHidden());

  useEffect(() => {
    const visibilityChange = getBrowserVisibilityProp();

    document.addEventListener(visibilityChange, onVisibilityChange, false);

    return () => {
      document.removeEventListener(visibilityChange, onVisibilityChange);
    };
  }, []);

  useEffect(() => {
    if (!isVisible) {
      start = new Date().getSeconds();
    } else {
      end = new Date().getSeconds();
    }

    if (end - start >= duration && isMobile()) {
      popupStore.onConnectionError(true);
      gameLiveConnection.stop();
    }
  }, [isVisible]);
}
